import { NoddiBadge } from 'noddi-ui-web';
import { formatPhoneNumber } from 'noddi-util';
import { WorkerAvatar } from '../ServiceWorker/WorkerAvatar';

type Props = {
  firstName: string;
  lastName: string;
  email?: string | null;
  phoneNumber?: string | null;
  /** Label for the administrator badge; omitted for members who are not one. */
  adminLabel?: string;
  /** Label for the employee badge; omitted when this membership is not staff of a holder organization. */
  employeeLabel?: string;
};

export const MemberContactInfo = ({ firstName, lastName, email, phoneNumber, adminLabel, employeeLabel }: Props) => {
  const name = `${firstName} ${lastName}`.trim();

  return (
    <div className='flex min-w-0 items-center gap-2.5'>
      <WorkerAvatar name={name} size='md' />
      <div className='min-w-0'>
        <div className='flex min-w-0 flex-wrap items-center gap-2'>
          {name && <p className='truncate font-medium'>{name}</p>}
          {adminLabel && (
            <NoddiBadge variant='outline' className='shrink-0'>
              {adminLabel}
            </NoddiBadge>
          )}
          {employeeLabel && (
            <NoddiBadge variant='outline' className='shrink-0'>
              {employeeLabel}
            </NoddiBadge>
          )}
        </div>
        {email ? <p className='truncate text-sm text-muted-foreground'>{email}</p> : null}
        {phoneNumber ? (
          <p className='truncate text-sm text-muted-foreground'>{formatPhoneNumber(phoneNumber)}</p>
        ) : null}
      </div>
    </div>
  );
};
